




















































































































import Vue from "vue";
import Modal from "@/components/root/modal/Modal.vue";
import { ModalConfig } from "@/components/root/modal";
import SensitivityLabel from "@/components/SensitivityLabel.vue";
import { computed, onMounted, ref } from "@vue/composition-api";
import {
  InformationType,
  POPULATION_TYPE,
  SensitivityLevelHelper,
} from "@/common/models";
import { ICONS } from "@/common/icons.map";
import { Filters } from "@/common/filters.global";
import TrustSlider from "./TrustSlider.vue";
import { get_entity_familiarities_status } from "../data/api";
import { SharedState } from "@/common/state";
import { clone, delayBy, find_last_index, groupBy } from "@/fp";
import { FamiliarityStatus } from "../data/models";
import TrustedLabelsPopup from "./TrustedLabelsPopup.vue";
import { UsePendingObject } from "@/common/composition/pending-collection";
import Actions from "./Actions.vue";
import ModalHeader from "./ModalHeader.vue";
import { state } from "../data/state";
import Spinner from "@/components/Spinner.vue";
import CurrentTrustStatusVue from "./CurrentTrustStatus.vue";
export default Vue.extend({
  components: {
    Modal,
    SensitivityLabel,
    TrustSlider,
    TrustedLabelsPopup,
    Actions,
    ModalHeader,
    Spinner,
    CurrentTrustStatusVue,
  },

  props: ["modalData"],
  setup(props, { emit }) {
    const is_loading = ref(true);
    const info_types_familiarities = UsePendingObject<number>(
      {},
      (trust_level_1, trust_level_2) => trust_level_1 == trust_level_2
    );
    const { pending_items: familiarity_status } = info_types_familiarities;

    const info_types = computed(() => {
      const { info_types } = props.modalData as { info_types: string[] };

      return info_types
        .filter((id) => id !== SharedState.default_label_id.value)
        .map((id) => {
          const L1s = SharedState.typesByCategories.value.get(
            id
          ) as InformationType[];
          console.log("L1s::", info_types, L1s);
          const L1s_by_sensitivity = groupBy("sensitivity", L1s);
          return {
            icon: Filters.l0IconById(id),
            name: Filters.l0Name(id),
            id,
            labels: Array.from(L1s_by_sensitivity.entries()).sort(
              // @ts-ignore
              (a, b) => b[0] * 10 - a[0] * 10
            ),
          };
        });
    });

    const current_focused_slider_index = ref(0);
    const focused_info_type_id = computed(() => {
      const type = info_types.value[current_focused_slider_index.value];
      if (type) {
        return type.id;
      } else {
        return "";
      }
    });
    const focused_info_type_name = computed(() => {
      const type = info_types.value[current_focused_slider_index.value];
      if (type) {
        return type.name;
      } else {
        return "";
      }
    });

    const modal_config = computed(() => {
      return {
        title: "",
        desc: "",
        blank: true,
        backdropDismiss: true,
        width: 72 + info_types.value.length * 10 + "rem",
        height: "45rem",
      } as ModalConfig;
    });

    const entity_type_icon = computed(() => {
      const type: POPULATION_TYPE = (props.modalData as {
        entity: { type: POPULATION_TYPE };
      }).entity.type;
      return ICONS.ENTITIES.get(type);
    });

    const sensitivity_levels = [
      [3, "High sensitivity"],
      [2, "Medium sensitivity"],
      [1, "Low sensitivity"],
      [0, "No sensitivity"],
    ];

    onMounted(async () => {
      const { entity, info_types } = props.modalData as any;
      const filtered_info_types = info_types.filter(
        (id: string) => id != SharedState.default_label_id.value
      );
      console.log("info_types::", filtered_info_types);
      console.log("MANAGE TRUST MODAL::", entity);
      const to_virtual_label = SharedState.getVirtualLabelByLabelCategory;
      const virtual_labels = filtered_info_types
        .map((l0_id: string) => [
          to_virtual_label(l0_id, "High").id,
          to_virtual_label(l0_id, "Medium").id,
          to_virtual_label(l0_id, "Low").id,
          to_virtual_label(l0_id, "None").id,
        ])
        .flat();

      let entity_id = entity.email || entity.name; //entity.id.split("_")[0];
      if (entity.type === POPULATION_TYPE.DEPARTMENT) {
        entity_id = entity.id;
      }
      console.log("entity_id::", entity_id);
      if (virtual_labels.length == 0) {
        return;
      }
      const res = await get_entity_familiarities_status({
        entityId: entity_id,
        labelIds: virtual_labels,
        type: entity.type,
      });

      if (res.success) {
        const status_by_l0 = groupBy(
          "l0",
          res.value
            .map((l) => {
              const v_label =
                SharedState.indexed_virtualLabels.value[l.labelId];
              return {
                ...l,
                l0: v_label.parentId,
                sensitivity: v_label.sensitivity,
              };
            })
            .sort((a, b) => a.sensitivity - b.sensitivity)
        );
        const familiarities = (filtered_info_types as string[]).reduce(
          (acc, id) => {
            const highest_trusted_sensitivity = [
              ...(status_by_l0.get(id) || []),
            ].reduce((acc, item) => {
              if (item.status === "trusted") {
                return Math.max(item.sensitivity, acc);
              }
              return acc;
            }, -1);
            acc[id] =
              highest_trusted_sensitivity > -1
                ? SensitivityLevelHelper.floatToInt(highest_trusted_sensitivity)
                : -1;
            console.log("acc[id]", acc[id]);
            return acc;
          },
          {} as { [key: string]: number }
        );

        info_types_familiarities.init(familiarities);
      }
      await delayBy(200);
      is_loading.value = false;
    });

    const labels_in_sensitivity_range = computed(() => {
      const focused_slider_info_type_id =
        info_types.value[current_focused_slider_index.value].id;
      return [
        focused_slider_info_type_id,
        3,
        info_types.value.find((l) => l.id === focused_slider_info_type_id)
          ?.labels,
      ];
    });

    const submit_changes = () => {
      info_types_familiarities.commit_changes();
      const { entity } = props.modalData as { entity: any };
      const entity_id =
        entity.type == POPULATION_TYPE.DEPARTMENT
          ? entity.id
          : entity.email || entity.name;

      Object.entries(familiarity_status.value).forEach(
        ([l0_id, sensitivity_threshold]) => {
          state.update_entity_status({
            entity_type: entity.type,
            entity_id,
            l0_id,
            threshold: sensitivity_threshold,
          });
        }
      );
      emit("submit", clone(info_types_familiarities.pending_items.value, true));
    };

    const update_info_type_sensitivity_trust = (
      index: number,
      id: string,
      val: number
    ) => {
      current_focused_slider_index.value = index;
      info_types_familiarities.update_item(id, val);
    };

    return {
      is_loading,
      familiarity_status,
      modal_config,
      entity_type_icon,
      info_types,
      sensitivity_levels,
      current_focused_slider_index,
      show_actions: info_types_familiarities.has_pending_changes,
      update_info_type_sensitivity_trust,
      discard_changes: info_types_familiarities.discard_changes,
      submit_changes,
      focused_info_type_id,
      labels_in_sensitivity_range,
      focused_info_type_name,
    };
  },
});
